<template>
  <b-container>
    <ListBlock blogName="기술블로그"></ListBlock>
  </b-container>
</template>

<script>
import ListBlock from "@/components/Blocks/ListBlock.vue";

export default {
  components: {
    ListBlock
  }
};
</script>

<style></style>
